<!--
 * @Author: xing.huang
 * @Date: 2021-11-30 10:39:32
 * @LastEditTime: 2022-01-07 11:24:51
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\report\productionReport\index.vue
 * 
-->
<template>
  <div id="production-report">
    <el-card style="
        font-size: 16px;
        color: rgb(51, 51, 51);
        height: 50px;
        line-height: 30px;
        width: 100%;
      ">生产报表</el-card>
    <div class="content">
      <el-card v-for="(item, index) in copyReportList" :key="index" :class="{ isActive: index == activeIndex }">
        <div @click="changeActive(item, index)" class="info">
          <img :src="item.url" />
          <span>{{ item.title }}</span>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductionReport",
  data() {
    return {
      activeIndex: null,
      reportList: [
        // {
        //   url: "/static/img/report/工序.png",
        //   title: "工序日产量统计",
        //   path: "/Report/ProductionReport/ProcedureReport"
        // },
        // {
        //   url: "/static/img/report/机组.png",
        //   title: "工单日产量统计",
        //   path: "/Report/ProductionReport/WorkshopReport"
        // },
        // {
        //   url: "/static/img/report/设备.png",
        //   title: "设备日产量统计",
        //   path: "/Report/ProductionReport/DeviceReport"
        // },
        // {
        //   url: "/static/img/report/在制品.png",
        //   title: "在制品统计",
        //   path: "/Report/ProductionReport/WipReport"
        // },
        {
          url: "/static/img/report/呆滞.png",
          title: "客户日产量报表",
          path: "/Report/ProductionReport/CustomerReport",
          permission:"btn_customer_days_menu"
        },
        {
          url: "/static/img/report/派工.png",
          title: "机组日产量报表",
          path: "/Report/ProductionReport/MachineReport",
          permission:"btn_workshop_days_menu"
        },
        {
          url: "/static/img/report/在制品.png",
          title: "生产成本报表",
          path: "/Report/ProductionReport/ProductionCosts",
          permission:"btn_production_cost_report"
        },
        {
          url: "/static/img/report/在制品.png",
          title: "生产工艺参数报表",
          path: "/Report/ProductionReport/ProductionProcess",
          permission:"btn_technology_param_report"
        },
        {
          url: "/static/img/report/设备.png",
          title: "交接班记录表",
          path: "/Report/shiftRecords",
          permission:"btn_team_report"
        },
      ],
      copyReportList: [],
      permission: {}
    };
  },
  mounted() {
    if (localStorage.getItem("permission")) {
      this.permission = JSON.parse(localStorage.getItem("permission"));
    }
    this.copyReportList = [];
    this.reportList.forEach(val => {
      Object.keys(this.permission).forEach(key => {
        if ((key == val.permission && this.permission[key]) ) {
          this.copyReportList.push(val);
        }
      });
    });
  },
  methods: {
    changeActive(item, index) {
      this.activeIndex = index;
      this.$router.push({ path: item.path });
    },
  },
};
</script>
<style scoped>
.content {
  display: flex;
  flex-wrap: wrap;
}

.info {
  width: 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.info img {
  width: 15%;
}

.info span {
  margin-top: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-size: 16px;
  color: #333;
  opacity: 0.7;
}
</style>
<style>
#production-report .el-card__body {
  padding: 10px 20px;
  height: calc(100% - 20px);
}

#production-report .el-card {
  border-radius: 10px;
  width: calc(25% - 17px);
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}

#production-report .content .el-card:nth-child(4) {
  margin-right: 0px;
}

#production-report .content .isActive {
  border: 1px solid #57c5ff;
}
</style>



// WEBPACK FOOTER //
// src/views/report/productionReport/index.vue